module.exports = __webpack_public_path__ + "static/media/fsc10.77ce0a0d.svg";